var React = require('react');

function ArrowsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M57.008 9.836h-39.5V3l-7.766 7.46L2 17.897l7.742 7.437 7.765 7.436v-6.813h39.5V9.837ZM25.481 32.978h39.5v-6.836l7.766 7.437 7.742 7.46-7.742 7.436-7.765 7.437V49.1h-39.5v-16.12Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10"}));
}

ArrowsInline.defaultProps = {"width":"82","height":"59","fill":"none"};

module.exports = ArrowsInline;

ArrowsInline.default = ArrowsInline;
